import React from 'react';
import ReferencesCard from './ReferencesCard';

export default function ReferencesContainer({ references }) {
  if (!references || references.length === 0) {
    return (
      <div className="text-center py-8">
        <div 
          className="inline-flex align-items-center justify-content-center mb-3"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white'
          }}
        >
          <i className="pi pi-users" style={{ fontSize: '2.5rem' }}></i>
        </div>
        <h3 className="text-700 mb-2">No hay referencias disponibles</h3>
        <p className="text-500 m-0">
          Este usuario no ha proporcionado información de referencias personales.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <h2 className="text-900 font-semibold mb-2 flex align-items-center gap-2">
          <i className="pi pi-users text-primary"></i>
          Referencias Personales
        </h2>
        <p className="text-600 m-0">
          {references.length} {references.length === 1 ? 'referencia registrada' : 'referencias registradas'}
        </p>
      </div>
      
      <div className="grid">
        {references.map((reference, index) => (
          <div key={reference.key || index} className="col-12 md:col-6 xl:col-4">
            <ReferencesCard reference={reference} index={index} />
          </div>
        ))}
      </div>
    </div>
  );
}

